import { lazy, Suspense } from "react";

import LoanFlow from "@src/containers/LoanFlow/LoanFlow.container.lazy";

import RouteLoadingIndicator from "@src/components/RouteLoadingIndicator/RouteLoadingIndicator";


const LazyContainer = lazy(() => import("./ConsentAuthorization.container"));

const Container = (props: any) =>
  <Suspense fallback={<RouteLoadingIndicator />}>
    <LoanFlow>
      <LazyContainer {...props} />
    </LoanFlow>
  </Suspense>;

export default Container;
